import React from "react";

// reactstrap components
import { Table, Media } from "reactstrap";
import NumberFormat from "react-number-format";

const TIER_STYLES = {
    Platinum: "bg-gradient-purple",
    Gold: "bg-gradient-warning",
    Silver: "bg-gradient-info",
    Bronze: "bg-gradient-danger",
};

const getInitials = (name) =>
    (name || "?")
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0])
        .join("")
        .toUpperCase();

const formatDate = (value) => {
    if (!value) return "-";
    return new Date(value).toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

class Loyalty extends React.Component {
    render() {
        const loyaltyMembers = this.props.loyaltyMembers || [];

        return (
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                    <tr>
                        <th scope="col">Member</th>
                        <th scope="col">Tier</th>
                        <th scope="col">Poin Loyalitas</th>
                        <th scope="col">Jumlah Transaksi</th>
                        <th scope="col">Bergabung Sejak</th>
                    </tr>
                </thead>
                <tbody>
                    {loyaltyMembers.length > 0 && loyaltyMembers.filter((member) => member).map((member) => (
                        <tr key={member.Id}>
                            <th scope="row">
                                <Media className="align-items-center">
                                    <div
                                        className="rounded-circle bg-gradient-default text-white d-flex align-items-center justify-content-center mr-3 font-weight-bold"
                                        style={{ width: 36, height: 36, fontSize: 13 }}
                                    >
                                        {getInitials(member.Name)}
                                    </div>
                                    <Media>
                                        <span className="mb-0 text-sm font-weight-bold">{member.Name}</span>
                                    </Media>
                                </Media>
                            </th>
                            <td>
                                <span className={`badge badge-md ${TIER_STYLES[member.Tier] || "bg-gradient-default"} text-white`}>
                                    {member.Tier}
                                </span>
                            </td>
                            <td>
                                <span className="font-weight-bold">
                                    <NumberFormat
                                        value={member.Points}
                                        displayType="text"
                                        thousandSeparator
                                    />
                                </span>{" "}
                                poin
                            </td>
                            <td>{member.TotalTransactions}</td>
                            <td>{formatDate(member.JoinDate)}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        )
    };
}

export default Loyalty;
